import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { initSentry } from './lib/sentry';
import { initAnalytics } from './lib/analytics';
import { router } from './router';
import './index.css';

// Error/perf monitoring as early as possible. No-op without a DSN.
initSentry();
// Google Analytics (GA4). No-op without VITE_GA_MEASUREMENT_ID.
initAnalytics();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
